module.exports = {
  nonWriteoffList: 'Danh sách chưa thanh toán',
  writeoffList: 'Tìm kiếm thanh toán',
  selectHedgingTheInvoice: 'Vui lòng tra cứu và chọn để đối trừ',
  return: 'Quay lại',
  query: 'Tìm kiếm',
  writeOffs: 'Thanh toán',
  confirm: 'Xác nhận',
  hedgingWriteOffs: 'Đối trừ thanh toán',
  actualReceiptAndPayment: 'Thu thực chi thực',
  revenueAndExpenditureMethod: 'Phương thức thu chi',
  all: 'Tất cả',
  receivables: 'Phải thu',
  payables: 'Phải trả',
  feeType: 'Loại chi phí:',
  domestic: 'Nội địa',
  international: 'Nước ngoài',
  writeOffMode: 'Chế độ thanh toán',
  charges: 'Chi phí',
  invoice: 'Hóa đơn',
  bill: 'Hóa đơn thanh toán',
  accountStatement: 'Bảng đối chiếu',
  paymentRequest: 'Yêu cầu thanh toán',
  revenueAndExpenditureDate: 'Ngày thu chi',
  writeOffSerialNumber: 'Số serial thanh toán',
  settleAccountsTo: 'Đối tượng thanh toán',
  chargeRemark: 'Ghi chú chi phí',
  applyState: 'Trạng thái yêu cầu',
  applicationNo: 'Số đơn yêu cầu',
  businessNumber: 'Mã nghiệp vụ',
  theOppositeSideInvoiceNo: 'Số hóa đơn đối tác',
  consignationCompany: 'Đơn vị ủy quyền',
  settlementAgent: 'Đại lý thanh toán',
  currency: 'Loại tiền',
  applicant: 'Người yêu cầu',
  businessType: 'Loại nghiệp vụ',
  dateOfApplication: 'Ngày yêu cầu',
  businessDate: 'Ngày nghiệp vụ',
  operation: 'Thao tác',
  sales: 'Bán hàng',
  wroteOffOrNot: 'Đã xác nhận thanh toán chưa',
  businessReferenceNumber: 'Số tham chiếu nghiệp vụ',
  businessStatus: 'Trạng thái nghiệp vụ',
  separateNumber: 'Số đơn phụ',
  paymentNotificationNo: 'Số thông báo thanh toán',
  applicationDepartment: 'Phòng ban yêu cầu',
  paymentPeriod: 'Thời hạn thanh toán',
  amount: 'Số tiền',
  theAmountOfWriteOffs: 'Số tiền xác nhận',
  approvalStatus: 'Trạng thái phê duyệt',
  businessAuditor: 'Người kiểm tra nghiệp vụ',
  businessAuditDate: 'Thời gian kiểm tra nghiệp vụ',
  departmentAuditor: 'Người kiểm tra bộ phận',
  departmentAuditDate: 'Thời gian kiểm tra bộ phận',
  officeAuditor: 'Người kiểm tra thương mại',
  officeAuditDate: 'Thời gian kiểm tra thương mại',
  financialAuditor: 'Người kiểm tra tài chính',
  financialAuditDate: 'Thời gian kiểm tra tài chính',
  financeVerifyDate: 'Ngày kiểm tra tài chính',
  verificationStatus: 'Tình trạng thanh toán',
  remark: 'Ghi chú',
  totalAmountNtWrittenOff: 'Tổng số tiền chưa thanh toán',
  methodOfPayment: 'Phương thức thanh toán',
  claimState: 'Tình trạng nhận tiền',
  prePayment: 'Có phải là tiền thu trước',
  lastTimeBalance: 'Số dư lần trước',
  thisTimeWriteOff: 'Thanh toán lần này',
  thisTimeBalance: 'Số dư lần này',
  otherCurrency: 'Loại tiền khác',
  paymentMethod: 'Phương thức thu tiền',
  bankReceiptStatus: 'Tình trạng biên lai',
  ourSideBank: 'Ngân hàng bên tôi',
  ourSideAccount: 'Tài khoản bên tôi',
  proofNo: 'Số chứng từ',
  usePaymentRecord: 'Sử dụng ghi chép thanh toán',
  paymentAmount: 'Số tiền thanh toán',
  receiptAmount: 'Số tiền thu',
  theOppositeSideCompany: 'Đơn vị đối tác',
  theOppositeSideBank: 'Ngân hàng đối tác',
  theOppositeSideAccount: 'Tài khoản đối tác',
  exchangeGainsAndLosses: 'Lãi lỗ hối đoái',
  financialCharges: 'Chi phí tài chính',
  oddment: 'Thiếu hụt số lẻ',
  originalCurrencyExchangeDifference: 'Chênh lệch tỷ giá gốc',
  writeOffRemarks: 'Ghi chú thanh toán',
  paymentReceivedDate: 'Ngày thu tiền',
  paymentDate: 'Ngày thanh toán',
  confirmToWriteOff: 'Xác nhận thanh toán',
  cancel: 'Hủy bỏ',
  totalGainsAndLosses: 'Tổng hợp lãi lỗ',
  date: 'Ngày',
  method: 'Phương thức',
  use: 'Sử dụng',
  cancelUsed: 'Hủy sử dụng',
  record: 'Ghi chép',
  chargeItem: 'Tên chi phí',
  reconciliationStatus: 'Tình trạng đối chiếu',
  type: 'Loại',
  writeOffExchangeRate: 'Tỷ giá thanh toán',
  total: 'Tổng cộng',
  confirmedCharge: 'Chi phí đã xác nhận',
  subTotal: 'Tổng cộng',
  invoiceNo: 'Số hóa đơn',
  invoiceHeader: 'Tên hóa đơn',
  invoiceDate: 'Ngày lập hóa đơn',
  revenueAndExpenditureType: 'Loại thu chi',
  billNo: 'Số hóa đơn',
  accountStatementNo: 'Số đối chiếu',
  billType: 'Loại hóa đơn',
  useReceiptRecord: 'Sử dụng bản ghi thu tiền',
  cancelUsedReceiptRecord: 'Hủy sử dụng bản ghi thu tiền',
  cancelUsedPaymentRecord: 'Hủy sử dụng bản ghi chi tiền',
  mbl: 'Số đơn chính',
  itemNo: 'Mã dự án',
  bankReceiptNo: 'Số sao kê ngân hàng',
  settlementCompany: 'Đơn vị thanh toán',
  solicitationType: 'Loại nhận hàng',
  writeOffPerson: 'Người xóa sổ',
  amountRange: 'Khoảng tiền',
  writeOffDate: 'Ngày xóa sổ',
  RecheckDate: 'Ngày kiểm tra',
  advanceMoneyOrNot: 'Có ứng trước không',
  recheckOrNot: 'Đã kiểm tra chưa',
  proofOrNot: 'Đã tạo chứng từ chưa',
  proofDate: 'Ngày chứng từ',
  paymentType: 'Loại thanh toán',
  prepaidOrNot: 'Có trả trước không',
  theAmountOfWrittenOff: 'Số tiền đã xóa',
  balance: 'Số dư',
  actualReceiptAmount: 'Số tiền thực thu',
  actualPaymentAmount: 'Số tiền thực chi',
  creator: 'Người tạo',
  recheck: 'Kiểm tra',
  invalid: 'Hủy bỏ',
  invoicingInformation: 'Thông tin hóa đơn',
  unchecked: 'Bỏ chọn',
  writeOffCurrency: 'Loại tiền xóa sổ',
  chargeOriginalCurrency: 'Loại tiền gốc của chi phí',
  chargeOriginalAmount: 'Số tiền gốc của chi phí',
  chargeOriginalExchangeRate: 'Tỷ giá gốc của chi phí',
  rmbAmount: 'Nhân dân tệ',
  usdAmount: 'Đô la Mỹ',
  cancelRecheck: 'Hủy kiểm tra',
  editWriteOff: 'Sửa xóa sổ',
  cancelWriteOff: 'Thu hồi xóa sổ',
  viewDetails: 'Xem chi tiết',
  exportExcel: 'Xuất bảng chi tiết',
  proof: 'Chứng từ',
  refreshRate: 'Làm mới tỷ giá',
  refreshActualReceiptAndPaymentAmount: 'Làm mới số tiền thực thu/chi',
  writeOffType: 'Loại xóa sổ',
  vesselVoyage: 'Tên chuyến bay/Số chuyến',
  containerSizeAmount: 'Loại container/Số lượng container',
  monetaryEquivalent: 'Số tiền quy đổi',
  customerService: 'Dịch vụ khách hàng',
  totalWriteOffs: 'Tổng thanh toán',
  totalEquivalent: 'Tổng quy đổi',
  exportToExcel: 'Xuất Excel',
  exportPDF: 'Xuất PDF',
  print: 'In',
  close: 'Đóng',
  dayOfCreditTerm: 'Kỳ hạn thanh toán (ngày)',
  billPaymentNo: 'Số thông báo thanh toán',
  totalCurrency: 'Tổng theo loại tiền',
  rateBy: 'Tỷ giá thanh toán',
  rateByInvoice: 'Theo tỷ giá hóa đơn',
  rateByAverage: 'Theo tỷ giá trung bình',
  businessCreateDate: 'Ngày tạo nghiệp vụ',
  invoicingStatus: 'Trạng thái hóa đơn',
  searchReqCondition: 'Phải chọn ít nhất một điều kiện tìm kiếm',
  dateTo: 'Đến',
  lockCheckBoxDate: 'Truy vấn dữ liệu ngoài 2 năm',
  queryLotsOfData: 'Truy vấn dữ liệu ngoài 2 năm',
  writeOffDateNotEmpty: 'Ngày thanh toán không được để trống!',
  unlockWriteOffDateQuery: 'Nếu phạm vi ngày thanh toán lớn hơn 2 năm sẽ ảnh hưởng tốc độ tải dữ liệu, xác nhận truy vấn dữ liệu ngoài 2 năm?',
  voucherNo: 'Số chứng từ',
  voucherCreateDate: 'Ngày tạo chứng từ',
  chargeSettleAccountsTo: 'Đơn vị thanh toán chi phí',
  update: 'Cập nhật',
  strip: 'Điều',
  targetVoucherNo: 'Số chứng từ đối tác',
  voucherDate: 'Ngày chứng từ 2',
  sourceRateDiff: 'Chênh lệch tỷ giá gốc',
  warehouseNo: 'Số nhập kho',
  userDefinedField1: 'Trường tùy chỉnh 1',
  userDefinedField2: 'Trường tùy chỉnh 2',
  userDefinedField3: 'Trường tùy chỉnh 3',
  havingInvoiceingNoOrNot: 'Có số hóa đơn không',
  selectActualReceiptAndPayment: 'Chọn thực thu thực chi',
  noCurrencyRate: 'Không tìm thấy tỷ giá cho loại tiền {0}, vui lòng cập nhật tỷ giá liên quan!',
  selectMethodOfPayment: 'Vui lòng chọn phương thức thanh toán.',
  selectOurSideBank: 'Vui lòng chọn ngân hàng của chúng tôi.',
  rateByCharge: 'Theo tỷ giá chi phí',
  preExchangeDifference: 'Chênh lệch tỷ giá dự kiến',
  bankWaterNo: 'Số bảng kê ngân hàng',
  ReceivableSoldAmount: 'Số tiền phải thu đã thanh toán',
  PayableSoldAmount: 'Số tiền phải trả đã thanh toán',
  ActualAmountReceivable: 'Số tiền phải thu thực tế',
  ActualAmountPayable: 'Số tiền phải trả thực tế',
  ChargeOriginTotalAmount: 'Tổng chi phí ban đầu',
  FinancialExpensesBeAllocated: 'Có phân bổ chi phí tài chính không',
  FinanceExpensesAllocation: 'Phân bổ chi phí tài chính',
  ChargingDirection: 'Hướng thu chi',
  SelectChargeItem: 'Vui lòng chọn hạng mục thu phí',
  SelectAccountObject: 'Vui lòng chọn đơn vị thanh toán',
  FinanceChargeShareJobTip: 'Sau khi tích chọn, chi phí tài chính sẽ tự động phân bổ đều cho tất cả nghiệp vụ đối trừ trong lần này khi xóa sổ',
  NotSyncCannotModify: 'Dữ liệu đã đồng bộ lên nền tảng đám mây không thể sửa đổi hoặc hủy bỏ!',
  invoiceTitle: 'Invoice Title',
  writeoffMatchStatus: 'Match Status',
  matchStatusUnmatched: 'Unmatched',
  matchStatusAuto: 'Auto Written Off',
  matchStatusManual: 'Manual Write-off',
  matchStatusNoNeed: 'No Need Write-off',
  matchStatusReason: 'Reason for Status Change',
  writeoffSeqNoSource: 'Serial No. Source',
  sourceImport: 'Import',
  sourceSystem: 'System',
  modifyMatchStatus: 'Modify Match Status',
  modifyStatus: 'Modify Status',
  modifyReason: 'Reason',
  confirmModify: 'Confirm',
  modifySuccess: 'Successfully modified {0} records',
  lockedCannotModify: 'Locked, cannot modify',
  containsLockedStatus: 'Contains locked status, please select unmatched records',
  pleaseSelectUnmatched: 'Please select unmatched records',
  selectAtLeastOne: 'Please select at least one record'
}
